module.exports = __webpack_public_path__ + "media/images/yellow_dot-9889fd3e4c56b9fbb5d0746aa3aac686.svg";